module.exports = {
	"articleTitle1": "Best Italian Restaurant: Gratzi",
	"catImage": "greenstar.png",
	"totalCats": 1,
	"name": "Gratzi",
	"articleLink1": "https://www.michigandaily.com/article/best-italian-restaurant-gratzi",
	"articleLink2": "https://www.michigandaily.com/arts/04best-ann-arbor-italian-gratzi18",
	"articleSnippet1": "Apr 1, 2014 ... Each month, Gratzi Head Chef John Fisher crafts a new menu built around the \nflavors of a different region of Italy, bringing recipes to Ann Arbor ...",
	"articleSnippet2": "Apr 18, 2013 ... Dressed in crisp white button-ups, black aprons and stunning red ties, waiters at \nGratzi float table to table with decadent (yet simple) pasta ...",
	"foodRecommendations": [],
	"articleTitle2": "Best Italian: Gratzi",
	"address": "326 S Main St, Ann Arbor, MI 48104",
	"images": [],
	"position": {
		"lat": 42.278724,
		"lng": -83.748989
	},
	"totalMisc": 0,
	"categories": {
		"fooddrink": 1,
		"location": 1,
		"restaurant": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/gratzi.json
// module id = 885
// module chunks = 0